export default "__VITE_ASSET__Pi9R78QA__"